export const stepperData = [{ step: 1, value: "회원 유형 선택" }, { step: 2, value: "약관 동의" }, { step: 3, value: "정보 입력" }, { step: 4, value: "완료" }]
/** 병·의원 가입 — 약관 다음에 '병원 인증'(2026-10-10). 일반회원은 위 [stepperData] 그대로 */
export const clinicStepperData = [{ step: 1, value: "회원 유형 선택" }, { step: 2, value: "약관 동의" }, { step: 3, value: "병원 인증" }, { step: 4, value: "치과 정보" }, { step: 5, value: "완료" }]
export const RequiredFieldList = [
    "제목",
    "모집인원",
    "담당업무",
    "근무형태",
    "학력",
    "경력",
    "직급",
    "자격증",
    "급여타입",
    "근무요일",
    "근무시간",
    "접수기간 시작날짜",
    "접수기간 종료날짜",
    "전형 방법",
]

export const RESUME_FIELD_NAMES = {
	TITLE: "이력서 제목",
	ACADEMIC: "최종학력",
	CERTIFICATES: "자격증",
	RECRUITMENT_TYPES: "근무형태",
	WORKING_DAYS_TYPES: "근무요일",
	JOB_TASK_TYPES: "희망업종",
    };
